import { render, staticRenderFns } from "./history.vue?vue&type=template&id=10e9ffb9&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=10e9ffb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9ffb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/magonxesp/repos/RandomAnimePicker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e9ffb9')) {
      api.createRecord('10e9ffb9', component.options)
    } else {
      api.reload('10e9ffb9', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=10e9ffb9&scoped=true&", function () {
      api.rerender('10e9ffb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/history/history.vue"
export default component.exports